import React from "react";
import { BsChatDotsFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { resetUnreadCount } from "../ReduxToolkit/Reducers/ChatReducer";

const FloatingChatBubble = ({ onIsChatOpen, location }) => {
  const { unreadMessageCount } = useSelector((state) => state.chat);
  const dispatch = useDispatch();

  const handleChatOpen = () => {
    dispatch(resetUnreadCount());
    onIsChatOpen(true);
  };

  return (
    <>
      {!["/pos", "/chat", "/products/new"].includes(location.pathname) && (
        <button className="floating-chat-bubble" onClick={handleChatOpen}>
          {unreadMessageCount > 0 && (
            <span className="chat-notification-badge">
              {unreadMessageCount}
            </span>
          )}
          <BsChatDotsFill size={30} />
        </button>
      )}
    </>
  );
};

export default FloatingChatBubble;
